import { useNavigate } from "react-router-dom";
import {
  PAGE_NAME_LOGIN,
  PAGE_NAME_SELECT_MODEL,
  PAGE_NAME_TOP,
  PAGE_NAME_REGISTER_SUBJECTNAME
} from "../constants/common_constants";
import { useDtsAppContext } from "../components/provider/DtsAppContextProvider";

export type onOkState =
  //OKボタンを押下後、
  // 1)タブを閉じるか
  // 2)トップページに遷移するか
  // 3)型式選択画面に遷移するか
  // 4)リロードするか(トップページ限定)
  // 5)ログイン画面に遷移するか
  // 6)YDS/YOSに遷移するか
  // 7)何も起こらないか(ただエラーダイアログが閉じられる)
  | "closeTab"
  | "navigateToTopPage"
  | "navigateToEngineModelSelection"
  | "navigateToSubjectNameRegister"
  | "reload"
  | "login"
  | "ydsyos"
  | "";

export type errorState = {
  isShowErrorDialog: boolean;
  errorTitle: string;
  errorMessage: string;
  //OKボタンを押下後の挙動
  onOk?: onOkState;
};

export const useErrorDialog = () => {
  const navigate = useNavigate();

  // エラー情報（Contextから取得）
  const { errorState, seterrorState, splash } = useDtsAppContext();

  // エラーダイアログを表示
  const showErrorDialog = (
    title: string,
    message: string,
    onOk: onOkState = "" //デフォルト値：何も起こらない(ただエラーダイアログが閉じられる)
  ) => {
    seterrorState({
      isShowErrorDialog: true,
      errorTitle: title,
      errorMessage: message,
      onOk: onOk,
    });
  };

  // エラーダイアログを閉じる
  const closeErrorDialog = () => {
    // 指定しているタブを閉じた際の挙動を確認(デフォルト値＝何もしない、ただタブが閉じられる)
    const { onOk } = errorState;

    if (onOk === "closeTab") {
      window.close(); // タブを閉じる
    } else if (onOk === "navigateToTopPage") {
      navigate(`/${PAGE_NAME_TOP}`); // トップページに遷移する
    } else if (onOk === "navigateToEngineModelSelection") {
      navigate(`/${PAGE_NAME_SELECT_MODEL}`); //型式選択画面に遷移する
    } else if (onOk === "login") {
      //Memo:navigate()ではログイン画面に遷移されなかったため、window.location.assign()で画面遷移させる
      //2つの画面遷移の違いとして、windows.location.assign()はリロードあり、navigate()はリロードなしの違いがある
      window.location.assign(`./${PAGE_NAME_LOGIN}`); //ログイン画面に遷移する
    } else if (onOk === "ydsyos") {
      const ydsyos_uri = "https://yds-next.yanmar.com/";
      window.location.assign(ydsyos_uri); // YDS/YOSに遷移
    } else if (onOk === "navigateToSubjectNameRegister"){
      navigate(`${PAGE_NAME_REGISTER_SUBJECTNAME}`);
    }

    // トップページの場合
    if (onOk === "reload") {
      if (splash) {
        //スプラッシュ画面表示判定がtrueのとき, リロード
        window.location.reload();
      } else {
        // ユーザーID取得
        const userId =
          localStorage.getItem(
            `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.LastAuthUser`
          ) || "";
        if (!userId) {
          //ユーザーIDがない場合のみリロードする
          window.location.reload();
        }
      }
    }

    seterrorState({
      isShowErrorDialog: false,
      errorTitle: "",
      errorMessage: "",
      onOk: "",
    });
  };

  return {
    showErrorDialog,
    closeErrorDialog,
  };
};
